"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Which little learners can join the fun?",
  answer: "Our magical lessons are designed for children aged 4 to 12. We group kids by age and level so everyone feels confident and excited to explore their new language journey!"
}, {
  question: "How do the live online classes work?",
  answer: "It’s like a digital playground! Your child joins a friendly teacher for a live video session filled with interactive games, catchy songs, and plenty of playful speaking practice."
}, {
  question: "Do parents need to know Spanish too?",
  answer: "Not at all! Our playful teachers guide the children every step of the way. We even provide fun 'adventure maps' for parents so you can see the progress your little one is making."
}, {
  question: "What makes LinguaKids different from apps?",
  answer: "Unlike apps, we focus on real human connection. Our live teachers build confidence, encourage curiosity, and adapt to your child’s unique energy in real-time."
}, {
  question: "Is it easy to schedule our lessons?",
  answer: "Absolutely! We know families are busy, so we offer flexible scheduling that fits your life. You can easily book or move lessons through our simple, parent-friendly portal."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="130953" id="common-questions" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div ref={ref} className={`mx-auto max-w-3xl px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold tracking-tight text-foreground sm:text-5xl">
            Curious Questions
          </h2>
          <p className="mt-4 text-xl leading-8 text-muted-foreground font-sans">
            Find all the answers about starting your child&apos;s magical Spanish adventure with LinguaKids.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
              <AccordionTrigger className="text-left text-lg sm:text-xl font-serif font-bold text-foreground hover:text-primary transition-colors py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-lg leading-relaxed font-sans pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 flex flex-col items-center justify-center gap-4 text-center">
          <p className="text-xl font-sans text-muted-foreground">
            Ready to start the adventure? Let&apos;s chat about your child&apos;s journey!
          </p>
          <Button asChild size="lg" className="rounded-full px-10 py-7 text-lg font-bold bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl transition-transform hover:scale-105">
            <Link to="/ContactPage">Book a Trial Lesson</Link>
          </Button>
        </div>
      </div>
    </section>;
}